/* eslint-disable */
import './airbnb-style-datepicker-polyfills';

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export const debounce = (func, wait, immediate) => {
    let timeout;
    return function() {
        // @ts-ignore
        let context: any = this;
        let args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        }
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args)
    }
}

export const copyObject = obj => {
    return JSON.parse(JSON.stringify(obj));
}

export const findAncestor = (element, selector) => {
    if (!element) {
        return null;
    }
    if (typeof element.closest === 'function') {
        return element.closest(selector) || null;
    }
    while (element) {
        if (element.matches(selector)) {
            return element;
        }
        element = element.parentElement;
    }
    return null;
}

export const randomString = length => {
    let text = '';
    let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
};
